import { useCallback } from 'react';

/**
 * Simplified hook for GWP footer.
 * @param {Object} props
 * @param {Function} props.onNext
 * @param {Function} props.onClose
 * @param {boolean} props.isActionEnabled
 * @param {boolean} props.showAction
 * @returns {{ handleNext: () => void, isActionEnabled: boolean, onClose: Function, showAction: boolean }}
 */
export function useViewModel({ onNext, onClose, isActionEnabled = false, showAction }) {
  const handleNext = useCallback(() => {
    if (onNext) onNext();
  }, [onNext]);

  return {
    handleNext,
    isActionEnabled,
    onClose,
    showAction
  };
}
